import makeApiCall from "../master/axiosIndex";

const workBoqApis = {
  getWorkBoq: (params: any) =>
    makeApiCall({
      url: `/work-boq/list`,
      method: "get",
      params,
    }),
  getPendingApprovalsWorkBoq: (params: any) =>
    makeApiCall({
      url: `/work-boq/pending-approvals`,
      method: "get",
      params,
    }),
  createWorkBoq: (data: any) =>
    makeApiCall({ url: `/work-boq/create`, method: "post", data }),
  updateWorkBoq: (workBoqId: any, data: any) =>
    makeApiCall({
      url: `/work-boq/update`,
      method: "put",
      data,
    }),
  getWorkBoqById: (workBoqId: any) =>
    makeApiCall({
      url: `/work-boq/id/${workBoqId}`,
      method: "get",
    }),
  approveWorkBoq: (data: any) =>
    makeApiCall({ url: `/work-boq/approve`, method: "post", data }),
  rejectWorkBoq: (data: any) =>
    makeApiCall({ url: `/work-boq/approve`, method: "post", data }),
  workBoqDropdownAlongWithCategory: (siteId: any, dropdownFor: any) =>
    makeApiCall({
      url: `/work-boq/dropdown/${siteId}`,
      method: "get",
      params: { dropdownFor },
    }),
  getWorkBoqByIdWithCategory: (workBoqId: any, workCategoryId: any) =>
    makeApiCall({
      url: `/work-boq/id/${workBoqId}`,
      method: "get",
      params: { workCategoryId },
    }),
};

export default workBoqApis;
